/**
 * Centre an AdvancedMarker's content on its coordinate.
 *
 * `anchorPoint` and `AdvancedMarkerAnchorPoint` are deprecated in favour of
 * `anchorLeft`/`anchorTop`, which take the *negated* offset — the old
 * `CENTER` (`["50%", "50%"]`) becomes `-50%` on both axes.
 *
 * Spread both onto the marker: setting either one makes the library ignore
 * `anchorPoint` completely, so they have to travel together.
 */
export const CENTERED_MARKER_ANCHOR = {
  anchorLeft: "-50%",
  anchorTop: "-50%",
};
